<template>
  <div class="chip" :style="{ backgroundColor: chipColor, color: labelColor }">
    <span class="label">{{ label }}</span>
    <button v-if="removable" class="remove" :style="{ color: labelColor }" @click="$emit('remove')">&times;</button>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label: string;
    removable?: boolean;
    chipColor?: string;
    labelColor?: string;
  }>(),
  {
    removable: false,
    chipColor: '#15930F1A',
    labelColor: '#15930F',
  }
);

defineEmits<{
  (e: 'remove'): void;
}>();
</script>

<style scoped>
.chip {
  display: inline-flex;
  align-items: center;
  max-width: max-content;
  max-height: 20px;
  padding: 2px 8px;
  font-size: 0.65rem;
  font-weight: 500;
  border-radius: 50px;
  user-select: none;
  transition: background-color 0.2s ease;

  flex-shrink: 0;
  flex-grow: 0;
  box-sizing: border-box;
}

.label {
  padding: 0 0.2em;
}

.remove {
  background: none;
  border: none;
  margin-left: 0.4em;
  font-size: 1rem;
  cursor: pointer;
  opacity: 0.6;
}
.remove:hover {
  opacity: 1;
}
</style>
